import $ from 'jquery';

$(document).on('click', 'button.readmore', (ev) => {
        const $el = $(ev.currentTarget);
        $el.html($el.hasClass('expanded') ? $el.attr('data-expand') : 'Réduire');
        $el.toggleClass('expanded');

});

$(document).ready(() => {
    $('.main .rich-text').each((i, el) => {
        const hr = el.querySelector('hr');
        if (hr === null) {
            return;
        }
        el.querySelectorAll('p:empty,b:empty,h3:empty').forEach(e => e.remove());

        const children = Array.from(el.childNodes);
        const readmoreSpan = el.querySelector('span.readmore');
        const buttonLabel = readmoreSpan ? readmoreSpan.innerHTML :'Lire la suite'; 
            $('<div class="hidden">')
            .insertAfter(hr)
            .append(children.slice(children.indexOf(hr) + 1, children.length));
                const button = $('<button>', {
                    'class': 'readmore',
                    'data-expand': buttonLabel,
                    'text': buttonLabel,
                })
            .replaceAll(hr);  
    });
});



// WEBPACK FOOTER //
// ./scripts/readmore.js